import { render } from "./CommodityContent.vue?vue&type=template&id=5032b37e"
import script from "./CommodityContent.vue?vue&type=script&lang=js"
export * from "./CommodityContent.vue?vue&type=script&lang=js"

import "./CommodityContent.vue?vue&type=style&index=0&id=5032b37e&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__